document.addEventListener('DOMContentLoaded', () => {
  // Find all sliders on the page
  const sliders = document.querySelectorAll('.category-nav-for-collection');

  // Debounce utility to limit event frequency
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  sliders.forEach(slider => {
    const sliderId = slider.id; // e.g., Slider-{{ section.id }}
    const progressFill = slider.nextElementSibling.querySelector('.progress-bar__fill');
    const prevButton = slider.nextElementSibling.querySelector('.nav-controls__button--left');
    const nextButton = slider.nextElementSibling.querySelector('.nav-controls__button--right');
    const upButton = slider.nextElementSibling.querySelector('.nav-controls__button--up');
    const downButton = slider.nextElementSibling.querySelector('.nav-controls__button--down');

    if (slider && progressFill) {
      const updateProgress = () => {
        if (window.innerWidth < 640) {
          // Small (< 640px): Vertical scroll
          const scrollHeight = slider.scrollHeight - slider.clientHeight;
          const scrollTop = slider.scrollTop;
          const progress = scrollHeight > 0 ? Math.min((scrollTop / scrollHeight) * 100, 100) : 0;
          progressFill.style.width = `${progress}%`;
          progressFill.style.display = 'block';
          console.log(`Width: ${window.innerWidth}, ScrollHeight: ${slider.scrollHeight}, ClientHeight: ${slider.clientHeight}, ScrollTop: ${scrollTop}, Progress: ${progress}%`);
        } else {
          // Medium and Large (>= 640px): Horizontal scroll
          const scrollWidth = slider.scrollWidth - slider.clientWidth;
          const scrollLeft = slider.scrollLeft;
          const progress = scrollWidth > 0 ? Math.min((scrollLeft / scrollWidth) * 100, 100) : 0;
          progressFill.style.width = `${progress}%`;
          progressFill.style.display = 'block';
          console.log(`Width: ${window.innerWidth}, ScrollWidth: ${slider.scrollWidth}, ClientWidth: ${slider.clientWidth}, ScrollLeft: ${scrollLeft}, Progress: ${progress}%`);
        }
      };

      const scrollDistance = () => {
        if (window.innerWidth < 640) {
          // Small (< 640px): Scroll by one row height
          const cardHeight = slider.querySelector('.category-card__image-container')?.offsetHeight || 0;
          const titleHeight = slider.querySelector('.category-card__title')?.offsetHeight || 0;
          return cardHeight + titleHeight + 15; // Image + title + gap
        } else {
          // Medium and Large (>= 640px): Scroll by one card width + gap
          return 160 + 40;
        }
      };

      // Update button functionality
      const updateButtonEvents = () => {
        if (prevButton && nextButton && upButton && downButton) {
          // Remove existing listeners to prevent duplicates
          prevButton.removeEventListener('click', prevButton._clickHandler);
          nextButton.removeEventListener('click', nextButton._clickHandler);
          upButton.removeEventListener('click', upButton._clickHandler);
          downButton.removeEventListener('click', downButton._clickHandler);

          // Horizontal navigation (Medium and Large)
          prevButton._clickHandler = () => {
            if (window.innerWidth >= 640) {
              slider.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
            }
          };
          nextButton._clickHandler = () => {
            if (window.innerWidth >= 640) {
              slider.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
            }
          };

          // Vertical navigation (Small)
          upButton._clickHandler = () => {
            if (window.innerWidth < 640) {
              slider.scrollBy({ top: -scrollDistance(), behavior: 'smooth' });
            }
          };
          downButton._clickHandler = () => {
            if (window.innerWidth < 640) {
              slider.scrollBy({ top: scrollDistance(), behavior: 'smooth' });
            }
          };

          // Add new listeners
          prevButton.addEventListener('click', prevButton._clickHandler);
          nextButton.addEventListener('click', nextButton._clickHandler);
          upButton.addEventListener('click', upButton._clickHandler);
          downButton.addEventListener('click', downButton._clickHandler);
        }
      };

      // Initial setup
      slider.addEventListener('scroll', debounce(updateProgress, 50));
      updateProgress();
      updateButtonEvents();

      // Re-apply on resize
      window.addEventListener('resize', debounce(() => {
        updateProgress();
        updateButtonEvents();
      }, 100));
    }
  });
});